/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import AppContainer from "../../Components/Structure/AppContainer";
import ActivationsCountToday from "../../Components/Statistics/AccountActivations/ActivationsCountToday";
import ActivationsPerSchool from "../../Components/Statistics/AccountActivations/ActivationsPerSchool";
import ActivationsList from "../../Components/Statistics/AccountActivations/ActivationsList";
import ajaxStudent from "../../util/remote/ajaxStudent";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import ActivationsPerRole from "../../Components/Statistics/AccountActivations/ActivationsPerRole";
import RegistrationsCountToday from "../../Components/Statistics/AccountActivations/RegistrationsCountToday";

function AccountActivationsPage() {
    const [activationsPerSchool, setActivationsPerSchool] = useState([]);
    const [activationsPerRole, setActivationsPerRole] = useState([]);
    const [registrationsPerSchoolToday, setRegistrationsPerSchoolToday] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const [loading3, setLoading3] = useState(false);
    const [loading4, setLoading4] = useState(false);
    const [loading5, setLoading5] = useState(false);

    const [startDate1, setStartDate1] = useState("");
    const [endDate1, setEndDate1] = useState("");
    const [activationsToday, setActivationsToday] = useState(false);
    const [allActivationsCount, setAllActivationsCount] = useState(false);
    const [activationsPerSchoolToday, setActivationsPerSchoolToday] = useState([]);
    const [loadingPage, setLoadingPage] = useState(true);

    // useEffect(() => {
    //       if (startDate || endDate) {
    //           searchTotalActivationsPerSchool();
    //       } else {
    //           getTotalActivationsPerSchool();
    //       }
    //   }, []);

    // useEffect(() => {
    //         getActivationsToday();
    //         countAllActivations();
    //         getTotalActivationsPerSchoolToday();
    // }, []);

    useEffect(() => {
      const fetchAll = async () => {
        setLoadingPage(true);
        await Promise.all([
          getActivationsToday(),
          startDate || endDate ? searchTotalActivationsPerSchool(): getTotalActivationsPerSchool(),
          startDate1 || endDate1 ? searchTotalActivationsPerRole(): getTotalActivationsPerRole(),
          countAllActivations(),
          getTotalActivationsPerSchoolToday(),
          getTotalRegistrationsPerSchoolToday()
        ]);
        setLoadingPage(false);
      };
    
      fetchAll();
    }, []);

    const getTotalActivationsPerSchool = async () => {
      setLoading(true);
        const server_response = await ajaxStudent.totalActivationsPerSchool();
        setLoading(false);
        if (server_response.status === "OK") {
          setActivationsPerSchool(server_response.details);
        } else {
          setActivationsPerSchool([]);
        }
    };

    const getTotalActivationsPerRole = async () => {
      setLoading3(true);
        const server_response = await ajaxStudent.totalActivationsPerRole();
        setLoading3(false);
        if (server_response.status === "OK") {
          setActivationsPerRole(server_response.details);
        } else {
          setActivationsPerRole([]);
        }
    };

    const searchTotalActivationsPerSchool = async () => {
      setLoading2(true);
        const server_response = await ajaxStudent.searchTotalActivationsPerSchool(startDate, endDate);
        setLoading2(false);
        if (server_response.status === "OK") {
          setActivationsPerSchool(server_response.details);
        } else {
          setActivationsPerSchool([]);
        }
    };

    const searchTotalActivationsPerRole = async () => {
      setLoading4(true);
      const server_response = await ajaxStudent.searchTotalActivationsPerRole(startDate1, endDate1);
      setLoading4(false);
      if (server_response.status === "OK") {
        setActivationsPerRole(server_response.details);
      } else {
        setActivationsPerRole([]);
      }
    };

    const getActivationsToday = async () => {
        const server_response = await ajaxStudent.activationsToday();
        if (server_response.status === "OK") {
          setActivationsToday(server_response.details);
        } else {
          setActivationsToday("404");
        }
    };

    const countAllActivations = async () => {
      const server_response = await ajaxStudent.countAllActivations();
      if (server_response.status === "OK") {
        setAllActivationsCount(server_response.details);
      } else {
        setAllActivationsCount("404");
      }
    };

    const getTotalActivationsPerSchoolToday = async () => {
      const server_response = await ajaxStudent.totalActivationsPerSchoolToday();
      if (server_response.status === "OK") {
        setActivationsPerSchoolToday(server_response.details);
      } else {
        setActivationsPerSchoolToday("404");
      }
    };

    const getTotalRegistrationsPerSchoolToday = async () => {
      setLoading5(true);

      const server_response = await ajaxStudent.totalRegistrationsPerSchoolToday();
      setLoading5(false);
      if (server_response.status === "OK") {
        setRegistrationsPerSchoolToday(server_response.details);
      } else {
        setRegistrationsPerSchoolToday("404");
      }
    };


    const setActivations = (e) => {
      e.preventDefault();
      setStartDate("");
      setEndDate("");
      getTotalActivationsPerSchool();
      
    };

    const setActivations1 = (e) => {
      e.preventDefault();
      setStartDate1("");
      setEndDate1("");
      getTotalActivationsPerRole();
      
    };

  return (
    <AppContainer title="Account Activations">
      <Toaster position="top-center" reverseOrder={false} />
      {loadingPage ? (
                                // Full page skeleton loader
                                <div style={{ padding: 40 }}>
                                  <Skeleton height={40} width={300} style={{ marginBottom: 20 }} />
                                  <Skeleton height={200} style={{ marginBottom: 20 }} />
                                  <Skeleton count={5} height={30} style={{ marginBottom: 10 }} />
                                </div>
                              ) : (
      <div className="row">
        <div className="col-lg-4">
          <div className="row">
          <ActivationsCountToday activationsPerSchoolToday={activationsPerSchoolToday} cardActivationsToday={activationsToday[4]} wbActivationsToday={activationsToday[12]} />
          <RegistrationsCountToday registrationsCountToday={registrationsPerSchoolToday} loading={loading5}/>
            <ActivationsPerSchool activationsPerSchool={activationsPerSchool} loading={loading} loading2={loading2}
            startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} searchActivations={searchTotalActivationsPerSchool}
            resetSearch={setActivations}/>
            <ActivationsPerRole activationsPerRole={activationsPerRole} loading={loading3} loading2={loading4}
            startDate={startDate1} setStartDate={setStartDate1} endDate={endDate1} setEndDate={setEndDate1} searchActivations={searchTotalActivationsPerRole}
            resetSearch={setActivations1}/>
          </div> 
        </div>
        
        <div className="col-lg-8">
          <div className="row">
            <div class="col-lg-12">
                <div class="card custom-card" style={{ paddingBottom: "10px" }}>
                    <div className="card-body map-card gradient-my-blue">
                        <div class="item-title mb-2" style={{ color: "white" }}>
                            <b>OVERALL</b>
                        </div>
                        <div class="row">
                        
                            <div class="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0">
                                <div class="text-center">
                                    <h2 class="mb-1 number-font" style={{ color: "white" }}>
                                        <span class="counter">
                                            {allActivationsCount? allActivationsCount.total_c:"..."}
                                        </span>
                                    </h2>
                                    <p class="mb-0 text-light"> Total Activations</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ActivationsList/>
            

          </div>
        </div>

        
      </div>)}
    </AppContainer>
  );
}

export default AccountActivationsPage;
